import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dashboard } from 'src/app/models/server/dashboard';
import { DashboardWorkflowDelayOptions } from 'src/app/models/server/dashboard-workflow-delay-options';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class DashboardService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Récupère les données du dashboard de suivi de la vue.
     * @param viewId : Id de la vue
     * @returns Les données du dashboard
     */
    public GetWorkflowDashboard<T>(dashboardType: string, viewId: number, dashboardOptions: DashboardWorkflowDelayOptions): Observable<Dashboard<T>> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                dashboardOptions: JSON.stringify(dashboardOptions),
            }),
        };

        return this.http.get<Dashboard<T>>(this.baseUrl + `/api/organizations/${this.organizationId}/dashboard?type=${dashboardType}&viewId=${viewId}`, httpOptions).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
